<template lang="html">
  <app-modal @close="close" class="alert">
    <app-modal-default v-if="product" @close="close">
      <template v-slot:header>
        {{$ml.get('Billing info')}}
        <!-- {{ $ml.get(`Payment method`) }} -->
      </template>
      <template v-slot:content>
        <div class="content">
          <!-- <Coupon v-model="coupon"/> -->
          <MarketStripeMethod
              @success="onSuccess"
              :product="product"
          />
        </div>
      </template>
    </app-modal-default>
  </app-modal>
</template>

<script>
import MarketStripeMethod from './MarketStripeMethod';
import {MarketAPI} from "@/api";
import {mapGetters} from "vuex";

export default {
  props: {
    productId: Number,
  },
  components: {
    MarketStripeMethod,
  },
  computed: {
    product () {
      return this.$store.getters["market/getProductById"](this.productId);
    }
  },
  methods: {
    onSuccess() {
      this.close();
      this.$router.push(`/dashboard/market/${this.product.type}/${this.productId}`);
    },
    close() {
      this.$emit('close');
    },
  },
}
</script>

<style lang="scss" scoped>

.app-modal-default {

  width: 350px;

  .app-loading {
    height: 100%;
    min-height: 200px;
  }

  .content {
    display: flex;
    flex-direction: column;
    align-items: stretch;

    .buttons {
      padding: 50px;
      width: 100%;
    }
  }
}

</style>
